import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DescriptionItemComponent } from "./description-item.component";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [DescriptionItemComponent],
  imports: [CommonModule, RouterModule],
  exports: [DescriptionItemComponent],
})
export class DescriptionItemModule {}
